import { ModalContent } from '../manage-tags/ModalContent';
import { StyledModal } from '../StyledModal';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { setStableVersion } from '../../services/DeploymentService';
import { Release } from '../../services/ReleaseService';

interface SetStableModalProps {
  release: Release;
  isVisible: boolean;
  onClose: () => void;
  refetch: () => void;
}

export const SetStableModal = (props: SetStableModalProps) => {
  const { release, isVisible, onClose, refetch } = props;
  const [error, setError] = useState<Error | undefined>();

  const handleClose = () => {
    refetch();
    onClose();
  };

  const { mutate, isPending: loading } = useMutation({
    mutationFn: setStableVersion,
    onError: (e) => {
      setError(e);
    },
    onSuccess: () => {
      handleClose();
    },
  });

  const onSetStableConfirm = async () => {
    if (!release || !release.id) {
      return;
    }
    setError(undefined);
    mutate(release.id);
  };

  return (
    <StyledModal
      isOpen={isVisible}
      onRequestClose={handleClose}
      label="set-stable-modal"
      style={{
        content: {
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          flexDirection: 'column',
          minWidth: '52vw',
          position: undefined,
        },
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 999,
        },
      }}
    >
      <ModalContent
        title={`Set ${release?.semver} as Latest Approved`}
        loading={loading}
        error={error}
        handleSubmit={onSetStableConfirm}
        submitDisabled={loading}
        handleClose={handleClose}
        buttonLabels={{
          loading: 'Setting Stable Version...',
          create: 'Set Stable Version',
        }}
      ></ModalContent>
    </StyledModal>
  );
};
